import {
  createColumn,
  formatAmount,
  formatDate,
  numberFormat,
} from "../../../../utils/helpers";
import { API_PAYMENTS_REPORT } from "../../../../utils/apis";
import dayjs from "dayjs";

const usePaymentsReport = () => {
  const tableColumns = () => [
    createColumn("payment_date", true, "Payment Date"),
    createColumn("number_plate", true, "Number Plate"),
    createColumn("period", true, "Period"),
    createColumn("district", true, "District"),
    createColumn("street_name", true, "Street Name"),
    createColumn("parking_yard_name", true, "Parking Yard"),
    createColumn("payment_item", true, "Payment Item"),
    createColumn("payment_mode", true, "Payment Mode"),
    createColumn("amount", false, "Amount"),
  ];

  const tableData = (data: any) => {
    if (!data?.data || !Array.isArray(data.data)) {
      return [];
    }

    return data.data.map((item: any) => {
      return {
        ...item,
        id: item.transaction_id,
        payment_date: formatDate(item?.payment_date),
        amount: numberFormat(item?.amount),
      };
    });
  };

  const viewData = (item: any) => {
    if (!item) {
      return {
        sections: [
          {
            title: "Error",
            fields: { message: "No data available" },
          },
        ],
      };
    }

    return {
      sections: [
        {
          title: "Payment Details",
          fields: {
            payment_date: formatDate(item?.payment_date),
            number_plate: item?.number_plate || "N/A",
            period: item?.period || "N/A",
            street_name: item?.street_name || "N/A",
            parking_yard: item?.parking_yard_name || "N/A",
            payment_item: item?.payment_item || "N/A",
            payment_mode: item?.payment_mode || "N/A",
            amount: formatAmount(item?.amount),
          },
        },
      ],
    };
  };

  const exportData = {
    api: API_PAYMENTS_REPORT,
    fileName: `payments_${new Date().toISOString().split("T")[0]}.xlsx`,
    isAsync: true,
    showCustomDateRange: true,
    start_date: "start_date",
    end_date: "end_date",
  };

  const activityFilter = "payments_report";

  const externalFilters = [
    {
      id: "payment_date",
      label: "Payment Date Range",
      type: "date",
      options: [],
      dateRangeNames: {
        startDateKey: "start_date",
        endDateKey: "end_date",
      },
    },
  ];
  const initialFilters = {
    start_date: dayjs().format("YYYY-MM-DD"),
    end_date: dayjs().format("YYYY-MM-DD"),
  };

  return {
    tableData,
    tableColumns,
    exportData,
    activityFilter,
    initialFilters,
    viewData,
    externalFilters,
  };
};

export default usePaymentsReport;
